export const globalConst = {
  cumulativeSumSeries: "cumulativeSumSeries",
  trendSeriesPrefix: "trend-",
};
